import ProductSet from './pages/productSet/productSet';

document.addEventListener('DOMContentLoaded', () => {
  new ProductSet().init();
});
